// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xNPC0","questions":"styles_questions__2iTjQ","footer":"styles_footer__1m9yW"};